import * as React from 'react'
import { Typography } from 'antd'

const { Paragraph } = Typography

interface Props {
    title: string
    value: string | any
}

export const StyledParagraph = ({ title, value }: Props) => (
    <Paragraph style={{ marginBottom: '0.6em' }}>
        <b>{title}: </b> {value}
    </Paragraph>
)
